import axios from "axios";


export const fetchDepartmentCall = () => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/Lab/labTests`);
  };
